import { Card, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React, { useCallback } from 'react';
import '../../css/metiers/metierCardView.css';

const MetierGridData = React.memo(({ index, style, data }) => {

    const { metiers, columns, filteredMetiersCount } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredMetiersCount);

    const handleMetierClick = useCallback((metierId) => navigate(`metier_details/${metierId}`), [navigate]);

    return (
        <Grid style={style} key={index} container spacing={2}>
            {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                const metierIndex = startIndex + idx;
                const metier = metiers[metierIndex];

                return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={metier ? metier.id : `skeleton-${metierIndex}`}>
                        <Card className='metiers_gridview_card'>
                            <CardActionArea onClick={metier ? () => handleMetierClick(metier.id) : undefined}>
                                {metier ? (
                                    <>
                                        <CardMedia
                                            component="img"
                                            height="192"
                                            loading='lazy'
                                            decoding='async'
                                            image={entityGridPhotoUrl(metier, 'metier', { size: 'small', fallback: machineDefaultImage })}
                                            alt={metier?.name}
                                        />
                                        <CardContent className='metiers_gridview_card_CardContent'>
                                            <Typography className='metiers_gridview_site_name' component="div">{metier?.name}</Typography>
                                            <Typography className='metiers_gridview_site_adress' component="div">{metier?.description || '--'}</Typography>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rectangular" height={192} />
                                        <CardContent className='machines_gridview_card_CardContent'>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </CardContent>
                                    </>
                                )}
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
});

export default MetierGridData;